import React from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";
import Layout from "../components/Layout";
import { LOCATIONS, PACKAGES } from "../data/content";

export default function Location() {
  const { slug } = useParams();
  const l = LOCATIONS[slug];
  if (!l) return <Layout><div className="max-w-3xl mx-auto px-6 py-32 text-center"><h1 className="text-3xl font-bold">Area not found</h1><Link to="/" className="text-pink-500 mt-4 inline-block">Back home</Link></div></Layout>;
  return (
    <Layout>
      <section className="relative overflow-hidden">
        <img src={l.hero} alt={l.name} className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] to-[#050505]/50" />
        <div className="relative max-w-4xl mx-auto px-6 py-24 md:py-32">
          <motion.p initial={{opacity:0}} animate={{opacity:1}} className="text-xs tracking-[0.3em] uppercase text-pink-500 font-bold mb-4">Mobile Detailing · {l.name}</motion.p>
          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tighter">{l.name}</h1>
          <p className="text-lg text-zinc-300 mt-5 max-w-2xl leading-relaxed">{l.intro}</p>
          <Link to="/book" target="_blank" rel="noopener noreferrer" className="mt-8 inline-flex items-center gap-2 bg-pink-600 hover:bg-pink-500 text-white font-semibold rounded-full px-8 py-4 transition-colors active:scale-95" data-testid="loc-book-btn">Book in {l.name} <ArrowRight size={18} /></Link>
        </div>
      </section>

      <article className="max-w-4xl mx-auto px-6 py-16 space-y-6">
        {l.body.map((p, i) => (<p key={i} className="text-zinc-300 leading-relaxed text-lg">{p}</p>))}
        <div className="flex flex-wrap gap-2 pt-4">
          {l.keywords.map((k) => (<span key={k} className="text-xs text-zinc-500 border border-white/10 rounded-full px-3 py-1 capitalize">{k}</span>))}
        </div>
      </article>

      <section className="max-w-5xl mx-auto px-6 py-12">
        <h2 className="text-2xl md:text-3xl font-bold tracking-tight mb-8">Popular packages in {l.name}</h2>
        <div className="grid gap-5 md:grid-cols-3">
          {PACKAGES.slice(3).map((p) => (
            <div key={p.key} className="rounded-2xl border border-white/10 bg-[#121212] p-6">
              <p className="text-xs uppercase tracking-widest text-pink-500 font-bold mb-2">{p.group}</p>
              <h3 className="text-lg font-bold">{p.name}</h3>
              <p className="text-sm text-zinc-400 mt-2 leading-relaxed">{p.desc}</p>
              <p className="mt-4 text-2xl font-extrabold">${p.sedan}<span className="text-sm text-zinc-500 font-normal"> / from</span></p>
            </div>
          ))}
        </div>
        <div className="mt-10 flex gap-4 flex-wrap">
          <Link to="/pricing" className="border border-white/25 hover:border-white/50 rounded-full px-6 py-3 transition-colors">Full pricing</Link>
          <Link to="/add-ons/exterior" className="border border-white/25 hover:border-white/50 rounded-full px-6 py-3 transition-colors">All add-ons</Link>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 py-8 mb-12">
        <div className="rounded-2xl border border-white/10 bg-[#121212] p-8">
          <h3 className="text-xl font-bold mb-4">Why {l.name} chooses The Pink Crew</h3>
          <div className="grid gap-3 sm:grid-cols-2">
            {["Fully mobile — we bring water & power","Pro-grade ceramic coatings & sealants","Transparent, upfront pricing","Flexible maintenance plans"].map((f)=>(
              <div key={f} className="flex items-center gap-3 text-zinc-300"><Check size={18} className="text-pink-500 shrink-0" />{f}</div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
